// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--PXwTW","active":"active--eAUgo","element":"element--KcfqN","accept":"accept--usN5w","cant":"cant--ne_Er"};